import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import i18next from 'i18next';

async function main() {
  await i18next.init(
    {
      fallbackLng: 'de',
      ns: ['common'],
      defaultNS: 'common',
      initImmediate: false,
      resources: {},
      load: 'currentOnly',
    },
    (err) => {
      if (err) {
        console.error(err);
      }
    }
  );

  bootstrapApplication(AppComponent, appConfig).catch((err) =>
    console.error(err)
  );
}

main();
